import { useTrackPageView } from '@savvy/deprecated-shared/tracking/use-track-page-view';
import { XLogin } from '@savvy/deprecated-shared/x-pages/savvy-auth/x-login';

function Login() {
  useTrackPageView();
  return <XLogin />;
}

export default Login;
